import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimesheetAndExpensesComponent } from './components/timesheet-and-expenses/timesheet-and-expenses.component';
import { TimesheetComponent } from './components/timesheet/timesheet.component';
import { ExpensesComponent } from './components/expenses/expenses.component';
import { AddressSelectComponent } from './components/address-select/address-select.component';
import { SharedModule } from '../shared/shared.module';
import { StartWorkComponent } from './components/start-work/start-work.component';
import { AddressStoreModule, PaceCoreModule, TimesheetStoreModule } from '@evorait/pace-core';
import { AddressSelectExpandableComponent } from './components/address-select/address-select-expandable/address-select-expandable.component';
import { AddressSelectInfoComponent } from './components/address-select/address-select-info/address-select-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { LetDirective } from '@ngrx/component';

@NgModule({
    declarations: [
        TimesheetAndExpensesComponent,
        TimesheetComponent,
        ExpensesComponent,
        AddressSelectComponent,
        StartWorkComponent,
        AddressSelectExpandableComponent,
        AddressSelectInfoComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        PaceCoreModule.forChild(),
        TimesheetStoreModule,
        AddressStoreModule,
        TranslateModule,
        LetDirective,
    ],
})
export class TimesheetModule {}
